import gql from 'graphql-tag';

import { Query } from 'core';

const USER_QUERY = gql`
  query User($username: String) {
    user(username: $username) {
      profile {
        collaborators {
          profile {
            fullName
            username
            avatar {
              url
            }
            imageFallbackChar
          }
        }
      }
    }
  }
`;

export class UserQuery extends Query {
  static conf = {
    GQL: USER_QUERY,
    varNames: ['username'],
  };
}
